import styled from 'styled-components'

const activeColor = ($color) =>
  $color === 'primary' ? 'var(--color-brand)' :
  $color === 'secondary' ? 'var(--vo-slate)' :
  'var(--color-brand)'

export const PaginationContainer = styled.nav`
  display: flex;
  align-items: center;
  gap: 4px;
`

const buttonBase = `
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  height: 32px;
  padding: 0 6px;
  border: 1px solid var(--vo-cloud);
  border-radius: var(--radius-lg);
  background: white;
  font-size: 14px;
  line-height: 1;
  cursor: pointer;
  transition: all 0.15s ease;
  user-select: none;

  &:hover:not(:disabled) {
    background: var(--vo-mist);
    border-color: var(--color-brand);
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`

export const PageButton = styled.button`
  ${buttonBase}
  font-weight: ${({ $active }) => ($active ? '700' : '400')};
  color: ${({ $active }) => ($active ? 'white' : 'var(--vo-ink)')};
  background: ${({ $active, $color }) => ($active ? activeColor($color) : 'white')};
  border-color: ${({ $active, $color }) => ($active ? activeColor($color) : 'var(--vo-cloud)')};
`

export const PageNav = styled.button`
  ${buttonBase}
  color: var(--vo-ink);
`

export const Dots = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  height: 32px;
  color: var(--vo-slate);
  font-size: 14px;
  user-select: none;
`
